import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import axios from "src/app/Service/axios";

import { OtherService } from './../../Service/other.service';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-smart-clustering',

  templateUrl: './smart-clustering.component.html',

  styleUrls: ['./smart-clustering.component.css']

})

export class SmartClusteringComponent implements OnInit {

  lst_Request: any = [];

  lst_Search: any = [];

  lst_Checked: any = [];

  list_Drivers: any = [];

  filteredDrivers: any = [];

  studentData: any;

  clusterColorMap = new Map<number, string>();

  showCustom_Map: boolean = false;

  mdl_Request: FormGroup = this.fb.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    lslMobileDomain: new FormControl('', Validators.required),

    tiStatus: new FormControl(''),

    tiGender: new FormControl(''),

    tiPassengers: new FormControl('4', Validators.required),

    fMaxDistanceInKm: new FormControl('', Validators.required),

  })

  mdl_Map: FormGroup = this.FormBuilder.group({

    fLat: new FormControl(0, Validators.required),

    fLon: new FormControl(0, Validators.required),

    strAddress: new FormControl('')

  });

  constructor(

    private router: Router,

    private route: ActivatedRoute,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService,

    private fb: FormBuilder,

    private _other: OtherService

  ) { }

  ngOnInit(): void {

    this.getDrivers()

    this.route.queryParamMap.subscribe(params => {

      this.mdl_Request.patchValue({

        lslMobileDomain: params.getAll('mobile') || [],

        tiStatus: params.get('tiStatus') || -1,

        tiGender: params.get('tiGender') || -1,

        tiPassengers: +params.get('tiPassengers') || 0,

        fMaxDistanceInKm: +params.get('fMaxDistanceInKm') || 0,

      })

      this.search_Request();

    });

  }

  async getDrivers() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_Mobile_Search4Asign`, model)).data.toString())

    this.list_Drivers = res;

    this.filteredDrivers = res;


  }

  search_Request = async () => {

    let model = this._other.stringNumberToNumber(this.mdl_Request.value);

    if (!model.lslMobileDomain.length) return this.Notification.showError('حداقل یک مدرسه را انتخاب کنید');

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`School_Passenger_Clusterer`, model)).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    this.lst_Request = res;

    this.lst_Search = res;

  }

  filter_list(val: any) {

    this.lst_Request = this.lst_Search.filter((el: any) => {

      return el.ClusterId?.toString() === val.value ||

        el.strPassenger_FullName?.toString().includes(val.value) ||

        el.strDriver_strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Request = this.lst_Search;

    }

  }

  filterDriver(val: any) {

    this.list_Drivers = this.filteredDrivers.filter((el: any) => {

      return el.strFullName?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Drivers = this.filteredDrivers;

    }

  }

  markAll() {

    if (this.lst_Checked.length == this.lst_Request.length) {

      this.lst_Checked = [];

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند')

    }

    else {

      this.lst_Checked = [];

      this.lst_Request.forEach((el: any) => {

        this.lst_Checked.push(el.iPassenger);

      })

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند');

    }

  }

  isSelected(item: number): boolean {

    return this.lst_Checked.indexOf(item) !== -1;

  }

  markSchedule(value: boolean, item: any) {

    if (value) {

      this.lst_Checked.push(item.iPassenger);

    }

    if (!value) {

      const index = this.lst_Checked.indexOf(item.iPassenger);

      if (index > -1) this.lst_Checked.splice(index, 1);

    }

  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'خوشه بندی هوشمند.xlsx');
  }

  getRowColor(clusterId: number): string {

    if (!this.clusterColorMap.has(clusterId)) {

      const color = this.hashColor(clusterId);

      this.clusterColorMap.set(clusterId, color);

    }

    return this.clusterColorMap.get(clusterId)!;
  }

  hashColor(id: number): string {

    // return '#ffff';

    const hue = (id * 137) % 360;

    return `hsl(${hue}, 60%, 80%)`;

  }

  assign_Modal() {

    if (!this.lst_Checked.length) return this.Notification.showError('حداقل یک دانش آموز را انتخاب کنید');

    $("#detailModal").modal("show")


  }

  async selectedDriver(item: any) {

    var model = this._other.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID,

      lstiPassenger: this.lst_Checked

    })

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`School_Mobile_Passengers_List_Asign`, model)).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    const removeSet = new Set(this.lst_Checked);

    this.lst_Request = this.lst_Request.filter(item => !removeSet.has(item.iPassenger));

    this.lst_Search = this.lst_Search.filter(item => !removeSet.has(item.iPassenger));

    this.lst_Checked = [];

    this.getDrivers();

    $("#detailModal").modal("hide");

    this.Notification.showSuccess('عملیات با موفقیت انجام شد');

  }

  open_Location(item) {

    this.mdl_Map.patchValue({

      fLat: item.fOrigiLat,

      fLon: item.fOriginLon,

      strAddress: item.strAddress

    });

    this.showCustom_Map = false;

    setTimeout(() => {

      this.showCustom_Map = true;

    }, 10);

  }

  async open_Detail(item) {

    this._other.Showspinner();

    var model = this._other.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    })

    let res = JSON.parse((await axios.post('School_Passenger_Info', model)).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    this.studentData = res[0];

    $('#studentModal').modal('show');


  }


}
